"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveStyle = void 0;

var _seamlessImmutable = require("seamless-immutable");

var _colors = _interopRequireDefault(require("../../scss/variables/_colors.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var retrieveStyle = function retrieveStyle(theme) {
  return {
    label: {
      color: "".concat((0, _seamlessImmutable.getIn)(theme, ['UTRatingStar', 'label', 'color'], _colors["default"].gray3), " !important")
    }
  };
};

exports.retrieveStyle = retrieveStyle;